import {
  useMutation,
  useQueryClient,
  UseQueryOptions,
  useQuery,
} from "@tanstack/react-query";
import {
  sendSMS,
  sendEmail,
  getClientUserMessageLogs,
  MessageLogResponse,
} from "./messagesApi";

export function useSendSMS() {
  return useMutation({
    mutationFn: ({ message, to }: { message: string; to: string }) =>
      sendSMS(message, to),
  });
}

export function useSendEmail() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: any) => sendEmail(payload),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "client-user-messageLogs",
          variables.clientUuid,
          variables.userUuid,
        ],
      });
    },
  });
}

export function useGetClientUserMessageLogs(
  clientUuid: string,
  userUuid: string,
  options?: UseQueryOptions<
    MessageLogResponse,
    Error,
    MessageLogResponse,
    [string, string, string]
  >,
) {
  return useQuery({
    ...options,
    queryKey: ["client-user-messageLogs", clientUuid, userUuid],
    queryFn: () => getClientUserMessageLogs(clientUuid, userUuid),
  });
}
